import { v1ApiClient } from '@/services';
import type { FeedbackListItemWithBlock } from '@/types/feedback';

import type { ChartFeedbackListReqParams } from './types';

export const fetchChartFeedbackList = async (
  workspace_alias: string,
  params: ChartFeedbackListReqParams,
  sortStatus: NotNullableSortStatusT,
  isPublic?: boolean,
): Promise<
  ResponseWithCount<{
    feedbacks: PaginatedData<FeedbackListItemWithBlock>[];
  }>
> => {
  const url = isPublic
    ? `/workspaces/${workspace_alias}/charts/feedbacks/public`
    : `/workspaces/${workspace_alias}/charts/feedbacks`;
  const res = await v1ApiClient.post(url, params, {
    params: {
      sortby: sortStatus.sortBy,
      order: sortStatus.orderStatus,
    },
  });
  return res.data;
};
